import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
import { layout } from '@prisjakt/ui-base';
import { Truncated } from '../../../../../components/truncated';

const productImageSize = '40px';

export const Products = styled.div`
  overflow: hidden;
`;

type InnerWrapperProps = {
  translateX: number;
};

export const InnerWrapper = styled.div<InnerWrapperProps>(
  props => css`
    display: flex;
    transform: translateX(${props.translateX}px);
    transition: transform 0.3s ease-out;
  `
);

type ProductProps = {
  width: number;
};

export const Product = styled.div<ProductProps>(
  props => css`
    display: flex;
    flex: 1 0 auto;
    justify-content: center;
    align-items: center;
    width: ${props.width}px;
    max-height: 56px;
    font-weight: 600;
    padding: ${layout.measurements.spacing050};
  `
);

export const ProductLink = styled(Link)`
  display: flex;
`;

export const ProductImage = styled.div`
  width: ${productImageSize};
  height: ${productImageSize};
  min-height: ${productImageSize};
  min-width: ${productImageSize};
  margin-right: ${layout.measurements.spacing050};
`;

export const ProductName = styled(Truncated)`
  max-height: 43px;
`;
